import React from "react";
import { Swiper, SwiperSlide } from "components/swiper";
import ExpertQuote from ".";
import { ReactComponent as RightArrow } from "assets/svgs/right-arrow.svg";
import { ReactComponent as LeftArrow } from "assets/svgs/left-arrow.svg";
import { formatTitle } from "helpers/format-title";

const ExpertQuotesSlider = ({ data }) => {

	const settings = {
		slidesPerView: 1,
		preventClicks: true,
		dots: true,
		pagination: { clickable: true },
		preventClicksPropagation: false,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		slidesPerGroup: 1,
		navigation: {
			enabled: true,
			nextEl: ".right-arrow-cs",
			prevEl: ".left-arrow-cs",
		},
	};

	return (
		<div className="!bg-cover" style={{ background: `url(${data?.bgImage})` }}>
			{data?.title && <h2 className="text-center mt-4 md:mt-0 mb-5 px-2 md:px-0">{formatTitle(data.title)}</h2>}
			<div className="quotes-slider flex justify-between h-fit relative">
				<Swiper {...settings}>
					{data.quotes.map((quote) => (
						<SwiperSlide key={quote._key}>
							<ExpertQuote data={quote} isSlider/>
						</SwiperSlide>
					))}
				</Swiper>
				<div className="left-arrow-cs md:left-4 left-0 md:w-16 w-8 flex" aria-label="Swipe left" tabIndex={0}>
					<LeftArrow className="!w-4 !h-8" role="presentation" aria-hidden="true" />
				</div>
				<div className="right-arrow-cs md:right-4 right-0 md:w-16 w-8 flex" aria-label="Swipe right" tabIndex={0}>
					<RightArrow className="!w-4 !h-8" role="presentation" aria-hidden="true" />
				</div>
			</div>
		</div>
	);
};

export default ExpertQuotesSlider;